
import CurrentLogo from './CurrentLogo';
import FormAddImage from '../dashboardComponents/FormAddImage';

export default function SetLogoForm({website}) {
  return (
    <div>
        <h2>בחר לוגו</h2>
        <FormAddImage website={website} directory={"logos"} dynamicPath={"settings.logo"} isArray={false} _required={true} label={"בחר לוגו"} text={"שמור"} type={"button"} _id={"logo_image_uploader"}/>
        {website?.settings?.logo!==null ? <CurrentLogo website={website} logo={website?.settings?.logo}/> : <h3>עדיין לא נבחר לוגו</h3>}
    </div>
  )
}
